/** Default familiars, mirrored from the seed data so the picker works before content downloads. */
export const FAMILIARS: { slug: string; name: string; emoji: string; blurb: string }[] = [
  {
    slug: "black-cat",
    name: "Black Cat",
    emoji: "🐈‍⬛",
    blurb: "Independent, intuitive and secretly very cuddly.",
  },
  {
    slug: "tabby-cat",
    name: "Tabby Cat",
    emoji: "🐈",
    blurb: "A cozy hearth guardian who supervises every spell.",
  },
  { slug: "raven", name: "Raven", emoji: "🐦‍⬛", blurb: "A clever messenger between worlds." },
  {
    slug: "crow",
    name: "Crow",
    emoji: "🪶",
    blurb: "A wise trickster who remembers every kindness.",
  },
  { slug: "owl", name: "Owl", emoji: "🦉", blurb: "A keeper of night wisdom." },
  { slug: "toad", name: "Toad", emoji: "🐸", blurb: "A humble, lucky garden companion." },
  { slug: "snake", name: "Snake", emoji: "🐍", blurb: "A symbol of rebirth and shedding the old." },
  { slug: "bat", name: "Bat", emoji: "🦇", blurb: "A night-flying guide through the dark." },
  { slug: "hare", name: "Hare", emoji: "🐇", blurb: "A moon-gazing spirit of spring." },
  { slug: "fox", name: "Fox", emoji: "🦊", blurb: "A cunning companion for clever magic." },
  { slug: "wolf", name: "Wolf", emoji: "🐺", blurb: "A loyal spirit of instinct and protection." },
  { slug: "moth", name: "Moth", emoji: "🦋", blurb: "A seeker of light drawn to hidden truths." },
  { slug: "spider", name: "Spider", emoji: "🕷️", blurb: "A patient weaver of fate." },
  { slug: "dog", name: "Dog", emoji: "🐕", blurb: "A devoted guardian with a loyal heart." },
  { slug: "goat", name: "Goat", emoji: "🐐", blurb: "A sure-footed spirit of abundance." },
  { slug: "dragon", name: "Dragon", emoji: "🐉", blurb: "An ancient guardian of treasure." },
  {
    slug: "will-o-wisp",
    name: "Will-o'-the-Wisp",
    emoji: "✨",
    blurb: "A flickering light that knows hidden paths.",
  },
  { slug: "custom", name: "Something else", emoji: "🔮", blurb: "Any creature you like." },
];

export function familiarEmoji(slug: string): string {
  return FAMILIARS.find((f) => f.slug === slug)?.emoji ?? "🔮";
}
